var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMexicanHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 326,
    y2: 517.317
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#ffd970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5288,
    stopColor: "#ffc35e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#fe9f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 161,
    x2: 347.818,
    xlinkHref: "#lg2",
    y1: 134.243,
    y2: 134.243
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 166.279,
    y2: 245.305
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 291.279,
    y2: 385.81
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22b27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017b4e"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 248.279,
    y2: 333.303
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 285.279,
    y2: 367.377
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 338.196,
    y2: 388.185
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 72,
    x2: 72,
    xlinkHref: "#lg1",
    y1: 242.46,
    y2: 278.112
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 194,
    x2: 194,
    xlinkHref: "#lg1",
    y1: 242.46,
    y2: 278.112
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 316,
    x2: 316,
    xlinkHref: "#lg1",
    y1: 242.46,
    y2: 278.112
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 438,
    x2: 438,
    xlinkHref: "#lg1",
    y1: 242.46,
    y2: 278.112
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.25,
    x2: 367.75,
    xlinkHref: "#lg5",
    y1: 148.399,
    y2: 148.399
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.42,
    x2: 353.58,
    xlinkHref: "#lg4",
    y1: 98.399,
    y2: 98.399
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m441.34 298.202c-7.03 0-12.729 5.699-12.729 12.729 0 95.729-77.882 173.611-173.612 173.611s-173.611-77.881-173.611-173.611c0-7.03-5.699-12.729-12.729-12.729s-12.729 5.699-12.729 12.729c.001 109.767 89.303 199.069 199.07 199.069s199.069-89.302 199.069-199.069c0-7.03-5.699-12.729-12.729-12.729z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.243 268.487h-286.486l57.769-203.868c10.834-38.232 45.738-64.619 85.474-64.619 39.736 0 74.64 26.387 85.473 64.618z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.757 268.487h286.486l-36.897-130.208h-212.692z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.175 385.147h-296.35c-58.998 0-106.825-47.827-106.825-106.824v-16.665c0-15.6 12.646-28.246 28.246-28.246h453.507c15.6 0 28.246 12.646 28.246 28.246v16.665c.001 58.997-47.826 106.824-106.824 106.824z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.175 385.147h-296.35c-58.998 0-106.825-47.827-106.825-106.824v-16.665c0-15.6 12.646-28.246 28.246-28.246h453.507c15.6 0 28.246 12.646 28.246 28.246v16.665c.001 58.997-47.826 106.824-106.824 106.824z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.822 259.975-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-8.756-8.756-21.891-10.453-32.352-5.105-.538 2.175-.828 4.447-.828 6.788v16.665c0 5.232.383 10.375 1.11 15.406 10.414-5.175 23.391-3.432 32.068 5.245l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c8.677-8.677 21.654-10.42 32.068-5.245.727-5.031 1.11-10.173 1.11-15.406v-16.665c0-2.341-.29-4.613-.827-6.788-10.458-5.348-23.593-3.65-32.349 5.105z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.822 296.805-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-10.871-10.87-28.495-10.87-39.366 0l-21.01 21.01c-10.871 10.871-28.495 10.871-39.366 0l-21.01-21.01c-8.754-8.754-21.886-10.453-32.346-5.107 1.605 12.846 5.493 24.98 11.242 35.99 7.59-.386 15.308 2.318 21.105 8.115l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c10.871-10.87 28.495-10.87 39.366 0l21.01 21.01c10.871 10.871 28.495 10.871 39.366 0l21.01-21.01c5.797-5.797 13.515-8.501 21.105-8.115 5.748-11.01 9.637-23.145 11.242-35.99-10.462-5.346-23.594-3.647-32.348 5.107z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.794 340.279c19.369 27.158 51.131 44.868 87.03 44.868h296.351c35.899 0 67.662-17.71 87.03-44.868z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 259.946,
    fill: "url(#SVGID_9_)",
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 259.946,
    fill: "url(#SVGID_10_)",
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 259.946,
    fill: "url(#SVGID_11_)",
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 259.946,
    fill: "url(#SVGID_12_)",
    r: 16
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m367.75 160.899h-225.5l7.08-25h211.34z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.58 110.899h-197.16l7.08-25h183z",
    fill: "url(#SVGID_14_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMexicanHat);
export default __webpack_public_path__ + "static/media/icon-mexican-hat.b84538c4eced5f83bc3823b9d5c264a2.svg";
export { ForwardRef as ReactComponent };